module.exports = __webpack_public_path__ + "a67d3c54dd37b63a3d6861c0c32fb7c2.png";